import { z } from "zod";
import { Timestamp } from "../common/time.js";
import { defineRoute } from "../http/route.js";
/**
 * The shop's payout account and its KYB, which gates selling (ENT-4, ADR 0017, card 036). While trade is paid offline
 * there are no payout accounts, and selling needs the shop's bank account instead (ADR 0021, card 102).
 */
const Seller = { surface: "tenant", auth: "user", permission: "shop:manage" };
export const KybStatus = z
    .enum(["not_started", "pending", "active", "rejected", "suspended"])
    .meta({ id: "KybStatus", description: "Changes only through the provider's events" });
export const PayoutAccountView = z
    .object({
    status: KybStatus,
    provider: z.enum(["fake", "airwallex"]).nullable().describe("Null before onboarding starts"),
    updatedAt: Timestamp.nullable(),
    required: z
        .boolean()
        .describe("Whether selling needs this account. False while trade is paid offline (ADR 0021): the shop's bank account is what selling needs then"),
})
    .meta({ id: "PayoutAccountView" });
export const getPayoutAccount = defineRoute({
    ...Seller,
    id: "payment.payout_account.get",
    method: "GET",
    path: "/v1/shop/payout-account",
    marks: ["tenant"],
    summary: "Where the shop's payout account stands; selling needs it active",
    prd: ["ENT-4"],
    responses: { 200: { description: "The payout account", schema: PayoutAccountView } },
    errors: ["AUTH_REQUIRED", "TENANT_REQUIRED", "PERMISSION_DENIED"],
});
export const startPayoutOnboarding = defineRoute({
    ...Seller,
    id: "payment.payout_account.onboarding",
    method: "POST",
    path: "/v1/shop/payout-account/onboarding",
    marks: ["tenant", "verified", "idem"],
    summary: "A link to the provider's hosted onboarding (KYB) for the shop's payout account; the account is created on the first call. `404` while trade is paid offline, when there are no payout accounts (ADR 0021)",
    prd: ["ENT-4"],
    responses: {
        200: {
            description: "Where to complete onboarding",
            schema: z.object({ url: z.url(), account: PayoutAccountView }),
        },
    },
    errors: [
        "AUTH_REQUIRED",
        "TENANT_REQUIRED",
        "PERMISSION_DENIED",
        "ENTERPRISE_NOT_VERIFIED",
        "ENTERPRISE_SUSPENDED",
        "AGREEMENT_ACCEPTANCE_REQUIRED",
        "NOT_FOUND",
        "INVALID_TRANSITION",
        "PROVIDER_UNAVAILABLE",
    ],
});
export const payoutAccountRoutes = [getPayoutAccount, startPayoutOnboarding];
//# sourceMappingURL=payout-account.routes.js.map